import { Document } from "@/generated/graphql";
import { defaultCollectionQuery } from "@/data/paginationConfig";
import CustomBreadcrumbs from "@/entities/CustomBreadcrumbs";

const getAttachedDocToApplicationsQuery = (document: Document): CustomBreadcrumbs => {
  return {
    breadcrumb_title: `With '${document.filename}' document attached`,
    filter_by_document_id: document.id,
    ...defaultCollectionQuery,
  };
}

export default getAttachedDocToApplicationsQuery;
